import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanReleasesRoute: InvariantJiraRoute = {
	name: 'software-plan-releases',
	path: '/jira/plans/:planId/scenarios/:scenarioId/releases',
};
